export default __webpack_public_path__ + "static/media/LogoSE-removebg.c0d00ef5.png";